<template>
  <div v-if="pending" class="text-center" style="transition: none !important;">
    <b-spinner />
  </div>

  <main v-else>
    <header class="justify-between align-items-stretch mb-3">
      <b-breadcrumb :items="breadcrumb" class="flex-grow-1 mb-0" />

      <b-dropdown
          v-if="$gate.allow('create', 'component') || $gate.allow('delete', item)"
          :id="`component_actions_dropdown_${id}`"
          :title="$t('Actions')"
          class="ml-3"
          no-caret
          right
      >
        <template slot="button-content">
          <fa fixed-width icon="ellipsis-v" />
        </template>

        <b-dropdown-item-button
            v-if="$gate.allow('create', 'component')"
            v-b-modal.duplicate-modal
            :disabled="item.busy"
        >
          <fa fixed-width icon="copy" />
          {{ $t('Duplicate') }}
        </b-dropdown-item-button>

        <b-dropdown-item
            v-if="$gate.allow('delete', item)"
            variant="danger"
            @click="handleDelete"
        >
          <fa fixed-width icon="trash" />
          {{ $t('Delete') }}
        </b-dropdown-item>
      </b-dropdown>
    </header>

    <duplicate-modal
        v-if="$gate.allow('create', 'component')"
        id="duplicate-modal"
        :api-url="duplicateUrl"
        :project-id="projectId"
        @duplicated="handleDuplicated"
    />

      <b-card
        :header="$t('Component')"
        class="mb-3"
        no-body
      >
          <b-form
            @keydown="item.onKeydown($event)"
            @submit.prevent="handleUpdate"
        >
          <b-card-body>
            <b-form-group
                :invalid-feedback="item.errors.get('name')"
                :label="$t('Name')"
                :state="item.errors.has('name') ? false : null"
                label-for="name"
            >
              <b-form-input
                  id="name"
                  v-model="item.name"
                  :readonly="$gate.deny('update', item)"
                  :state="item.errors.has('name') ? false : null"
                  autofocus
                  name="name"
              />
            </b-form-group>

            <b-form-group
                :invalid-feedback="item.errors.get('short_name')"
                :label="$t('Short name')"
                :state="item.errors.has('short_name') ? false : null"
                label-for="short_name"
            >
              <b-form-input
                  id="name"
                  v-model="item.short_name"
                  :readonly="$gate.deny('update', item)"
                  :state="item.errors.has('short_name') ? false : null"
                  maxlength="5"
                  name="short_name"
              />
            </b-form-group>
          </b-card-body>

          <b-card-footer v-if="$gate.allow('update', item)">
            <b-button
                :disabled="item.busy"
                type="submit"
                variant="primary"
            >
              {{ $t('Save') }}
            </b-button>
          </b-card-footer>
        </b-form>
  </b-card>

    <component-overview :project-id="projectId" :component-id="id" />
  </main>
</template>

<script>
import Form from 'vform';
import DuplicateModal from '@/components/DuplicateModal';
import itemMixin from "@/mixins/itemMixin";
import ComponentOverview from "@/components/components/ComponentOverview";

export default {
  name: 'BuildingComponent',
  components: {ComponentOverview, DuplicateModal},
  mixins: [itemMixin],
  props: {
    projectId: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      item: new Form({
        name: null,
        short_name: null,
        model_name: null
      }),
      project: {},
    };
  },
  computed: {
    resourceName() {
      return 'components'
    },
    baseUrl() {
      return `/api/projects/${this.projectId}/components`;
    },
  },
  methods: {
    handleDuplicated(data) {
      this.$router.push({
        name: 'projects.components.show',
        params: {
          projectId: this.projectId,
          componentId: data.id,
        },
      });
    },

    afterDelete() {
      this.$router.push({
        name: 'projects.show',
        params: {
          projectId: this.projectId,
        },
      });
    },

    setData(data) {
      this.project = data.project;

      this.breadcrumb = [
        {
          text: this.$t('Projects'),
          to: {name: 'projects.index'}
        }
      ].concat(data.breadcrumb);

      this.item.fill(data);
    },
  },
};
</script>
